import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, signal, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, UntypedFormArray } from '@angular/forms';
import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { API_METHOD_CONSTANTS } from '../../../../../constants/ngrx-store/core';
import { EMPLOYEE_METHOD_CONSTANT } from '../../../../../constants/ngrx-store/employee';
import { PERMISSION_CONSTANT } from '../../../../../constants/permission';
import { LocalStorageUtil } from '../../../../../core/utils/local-storage-util';
import { ModalButtonType } from '../../../../../models/common/modal/modal-config';
import { EmployeeStoreService } from '../../../../../state/modules/employee/employee-store.service';
import { EmployeeService } from '../../../../../state/modules/employee/services/employee.service';
import { NotificationComponent } from '../../../../shared/components/modals/notification/notification.component';
import { FORM_CONSTANTS, UNSAVED_CHANGES_MODAL_CONSTANTS } from './client-action.constant';
import { PERMISSIONV2 } from '../../../../../constants/permissionv2/role-permission';
import { MasterService } from '../../../../../state/master/services/master.service';
import { AssignTimesheetComponent } from '../assign-timesheet/assign-timesheet.component';

@Component({
  standalone: false,
  selector: 'kt-client-action',
  templateUrl: './client-action.component.html',
  styleUrls: ['./client-action.component.scss']
})
export class ClientActionComponent implements OnInit {
  /**
   * External Inputs
   */
  @Input() data;

  /**
   * Form constants
   */
  formConstants = FORM_CONSTANTS;

  /**
   * Reference to wizard
   */
  @ViewChild('wizard', { static: true }) el: ElementRef;
  @ViewChild(AssignTimesheetComponent, { static: false }) assignTimesheet: AssignTimesheetComponent;


  /**
  * Variable to handle naviagation
  */
  wizardRef = null;
  stepConfig = {
    currentForm: this.formConstants.PERSONAL_DETAIL,
    index: 1,
  };

  public empoloyeeInfo: any = null;
  public employee_id: number = null;
  PermissionV2 = PERMISSIONV2



  /**
  * Forms object for different tab
  */
  forms = {
    personalDetailForm:
    {
      form: new UntypedFormGroup({}),
      name: 'Personal Details',
      stepNo: 1,
    },
    addressForm: {
      form: new UntypedFormGroup({ user_business_address_type: new UntypedFormControl('PRIMARY') }),
      name: 'Address',
      stepNo: 2,
    },
    contactForm: {
      form: new UntypedFormGroup({}),
      name: 'Contact',
      stepNo: 3,
    },
    payRateForm:
    {
      form: new UntypedFormGroup({}),
      name: 'Pay-Rate',
      stepNo: 4,
    },
    jobInformationForm: {
      form: new UntypedFormGroup({}),
      name: 'Job Information',
      stepNo: 5,
    },
    bankDetailForm: {
      form: new UntypedFormGroup({}),
      name: 'Bank Detail',
      stepNo: 6,
    },
    assignLocationForm: {
      form: new UntypedFormGroup({ assignlocations: new UntypedFormArray([]) }),
      name: 'Assign Location',
      stepNo: 7,
    },
    assignTimesheetForm: {
      form: new UntypedFormGroup({ assignTimesheets: new UntypedFormArray([]) }),
      name: 'Assign Timesheet',
      stepNo: 8,
    },
  };

  masterBusinessLabel = MasterService.masterBusinessLabel

  startStep = 1;
  employeeData: any;
  loading = signal(false);
  clientId = null;
  locationId = null;
  options: any = { showCancel: false, class: 'create-mode-class' };
  permissionConstant = PERMISSION_CONSTANT;
  currentStep = null;
  isLoggedInUserProfile = false;
  employeeOnboardingData: any;
  subscriptions: Subscription[] = [];
  constructor(public activeModal: NgbActiveModal, public modalService: NgbModal, public employeeService: EmployeeService, public employeeStoreService: EmployeeStoreService, private changeDetectorRef: ChangeDetectorRef) { }

  ngOnInit() {

    if (this.currentStep) {
      this.stepConfig.currentForm = this.currentStep;
    }

    // When employee is added form scheduler we have to assign client and location id
    if (this.data && this.data.client_id && this.data.location_id) {
      this.clientId = this.data.client_id;
      this.locationId = this.data.location_id;
    }
  }

  employeeOnboardingFill(event = null) {
    this.subscriptions.push(this.employeeService.onboardingFillForEmployee(this.employeeData.employee_id).subscribe(data => {
      if (data.success && data.data && data.data.data) {
        this.employeeOnboardingData = data.data.data.onboardingDetail;
      }
    }));
  }


  setEmployeeDetails(data) {
    this.loading.set(false);
    this.changeDetectorRef.detectChanges();

    if (data.success) {
      if (data.data && data.data.employees && data.data.employees.length) {
        this.empoloyeeInfo = data.data.employees[0];
        const loginUserId = LocalStorageUtil.getUserId();
        if (loginUserId === this.empoloyeeInfo.employee_fk_user_id) {
          this.isLoggedInUserProfile = true;
        } else {
          this.isLoggedInUserProfile = false;
        }
        const formatedObj = { ...data.data.employees[0], ...data.data.employees[0].user };
        this.employeeData = formatedObj;
        this.employeeOnboardingFill();
      }
    }
  }
  ngAfterViewInit() {
    if (this.data && this.data.employee_id) {
      // this.loading = true;
      this.employeeStoreService.dispatchEmployeeCommon({
        callback: this.setEmployeeDetails.bind(this),
        module: EMPLOYEE_METHOD_CONSTANT.EMPLOYEE,
        method: API_METHOD_CONSTANTS.GET_BY_ID,
        data: { employee_id: this.data.employee_id },
      });


    }
    // setTimeout(() => {
    // this.setWizardStepperConfig();
    // }, 100);
  }

  /**
   * sets navigation config
   */
  setWizardStepperConfig() {
    this.wizardRef = new KTWizard(this.el.nativeElement, { startStep: this.startStep });
    // console.log(this.wizardRef);
  }

  /**
 * Check if any of the form is dirty(if there are unsaved change then let the user know)
 */
  closeModalHandler() {
    const modalConstantRef = UNSAVED_CHANGES_MODAL_CONSTANTS;
    let isTabDirty = false;
    let firstDirtyTab = null;
    let firstDirtyForm = null;
    modalConstantRef.message = 'There are Unsaved changes in the ';
    for (const form in this.forms) {
      if (this.forms[form].form.dirty || this.checkNestedFormDirty(form)) {
        modalConstantRef.message += this.forms[form].name + ', ';
        if (!isTabDirty) {
          firstDirtyTab = this.forms[form].stepNo;
          firstDirtyForm = form;
        }
        isTabDirty = true;

      }
    }

    modalConstantRef.message = modalConstantRef.message.replace(/,(?=\s*$)/, '');

    if (isTabDirty) {
      const modalRef: NgbModalRef = this.modalService.open(NotificationComponent, { centered: true });
      modalRef.componentInstance.options = modalConstantRef;
      modalRef.result.then((res) => {
        if (res.STATUS === ModalButtonType.OK) {
          this.activeModal.close();
        } else {
          // console.log(this.wizardRef);
          // this.wizardRef.goTo(firstDirtyTab);
          this.stepConfig.currentForm = firstDirtyForm;
        }
      });
    } else {
      this.activeModal.close();

    }

  }

  checkNestedFormDirty(formKey: string): boolean {
    switch (formKey) {
      case this.formConstants.ASSIGN_TIMESHEET:
        return this.isChildFormDirty(this.assignTimesheet, '_assignTimesheetForm');
      default:
        return false;
    }
  }

  isChildFormDirty(component: any, formKey: string): boolean {
    return component && component[formKey] && component[formKey].dirty;
  }
  /**
 * Storing the step and moving to that step if the api return success
 * @param {*} step
 */
  onStepClick(form: string) {
    if (this.loading()) {
      return;
    }

    if (this.employeeData && this.employeeData.employee_id) {
      this.stepConfig.currentForm = form;
    } else {
      // this.wizardRef.stop();
    }
  }
  /**
 * handle child tab callback
 */
  childTabCallback(event) {
    // console.log('child tab callback data', event);

    switch (event.type) {
      case 'CALLBACK_DATA':
        this.employeeData = { ...this.employeeData, ...event.data };
        this.empoloyeeInfo = this.employeeData;
        this.employeeOnboardingFill();
        break;

      case 'CLOSE':
        // logic for any unsaved data in any form
        this.activeModal.close();
        break;

      default:
      // nothing to do
    }

    if (event && !event.isUpdate) {
      this.stepConfig.currentForm = this.formConstants.ASSIGN_LOCATION;
    }
  }
}
